import styled from 'styled-components';

import Button from '@components/Button/next';
import Drawer, { DrawerTitle } from '@components/Drawer/next';

export const LocationSearchContentWrapper = styled.div`
  position: relative;

  & > div {
    height: 100%;
  }
`;

export const LocationItemsList = styled.div`
  width: 100%;
  max-height: 257px;
  overflow: auto;
  margin: 5px;
  border-radius: 5px;
  ::-webkit-scrollbar {
    width: 5px;
    background-color: ${({ theme }) => theme.palette.gray};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
  }
`;
export const IconWrapper = styled.div`
  margin-left: 10px;
`;
export const LocationAnimationErrorBox = styled.div`
  border-radius: 8px;
  overflow: hidden;
  &.location-animation-error {
    border: 1px solid ${({ theme }) => theme.palette.coral};
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

//==================================================
//==================================================
//==================================================

export const StyledListingLocationDrawer = styled(Drawer)`
  ${DrawerTitle} {
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.darkGrey};
    white-space: nowrap;
  }

  .select-content {
    min-width: 100%;
  }

  .select-text-content {
    width: 100%;
  }
  .select-text {
    width: 100%;
  }

  .select-input {
    width: 100%;
  }
` as any;

export const ResponsiveLocationDrawerContent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ResponsiveListingSearchLocationSelect = styled.div`
  height: 63px;
  margin: 0 15px 18px 15px;
  border-bottom: 1px solid rgba(75, 75, 75, 0.5);

  & div {
    padding: 0;
  }
`;

export const ResponsiveListingSearchDateRangePicker = styled.div`
  grid-row: 1/2;
  height: 100%;
  margin: 0 15px 0 15px;
  border-bottom: 1px solid rgba(75, 75, 75, 0.5);

  &.select-box-icon {
    display: none;
  }

  & div {
    padding: 0;
  }
`;

export const ResponsiveLocationListItems = styled.div`
  width: 100%;
  height: 100%;
  z-index: 10000;
`;

export const ResponsiveLocationItems = styled.div`
  padding: 0 15px;
  width: 100%;
  height: fit-content;
  height: 100%;
  overflow: auto;
  z-index: 999999999;
  transition: all 0.5s;
  flex: 1;
`;

export const ListItemsWrappedByHeader = styled.div`
  max-height: 300px;
  height: fit-content;
  padding: 20px 0;
`;

export const ResponsiveSearchDrawerButtonWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 15px;
  box-shadow: 0 10px 40px 0 rgba(58, 58, 58, 0.2);
  background-color: ${({ theme }) => theme.palette.white};
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  width: 100%;
  display: block;
  font-weight: bold;
  font-size: 16px;
  border-radius: 8px;
`;
